import {Recco, Account, ENTITY_TYPE, Resource, WordCloudData, TrendingRecco} from '.';
import {LooseObject} from '../types';

export class EntityPageMeta {
  account: Account;
  entity?: LooseObject;
  entityType: ENTITY_TYPE;
  famTrusts: number = 0;
  isFollowed: boolean = false;
  id: string;
  resource: Resource;
  publicReccoCount: number = 0;
  privateReccoCount: number = 0;
  reccoCount: number = 0;
  url: string;

  constructor(json: any) {
    this.account = json?.account && new Account(json.account);
    this.entity = json.entity;
    this.entityType = json.entityType;
    this.id = json.id;
    this.isFollowed = json.isFollowed;
    this.famTrusts = json?.famTrusts;
    this.publicReccoCount = json?.publicReccoCount;
    this.privateReccoCount = json?.privateReccoCount;
    this.reccoCount = json?.reccoCount;
    this.resource = json?.resource && new Resource(json.resource);
    this.url = json?.url;
  }
}

export class EntityPageData {
  data: Recco[];
  meta: EntityPageMeta;
  trendingRecco: TrendingRecco[];
  wordCloud: WordCloudData[];
  constructor(json: any) {
    this.data = json.data?.map((rec: any) => new Recco(rec?.entity));
    this.meta = json?.meta && new EntityPageMeta(json.meta);
    this.trendingRecco = json.trendingRecco?.map((rec: any) => new TrendingRecco(rec));
    this.wordCloud = json.wordCloud?.map((rec: any) => new WordCloudData(rec));
  }
}
